// extracted by mini-css-extract-plugin
export var container = "_rq-0";
export var dotAnimation = "_rq-2";
export var dotsLoading = "_rq-1";